module.exports = __webpack_public_path__ + "img/mx_extensiondegarantia.56f415ed.png";